import { render, staticRenderFns } from "./LiveComments_Review.vue?vue&type=template&id=713e0d11&scoped=true"
import script from "./LiveComments_Review.vue?vue&type=script&lang=js"
export * from "./LiveComments_Review.vue?vue&type=script&lang=js"
import style0 from "./LiveComments_Review.vue?vue&type=style&index=0&id=713e0d11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713e0d11",
  null
  
)

export default component.exports